<template>
	<div class="feedback">
        <h3>2025年华统股份</h3>
        <h3 style="margin-bottom: 40px;">股东回馈报名表</h3>
       
        <main>
            <p>添加问卷说明</p>
            <el-divider></el-divider>
            <p><span>*</span>   1. 请填写您的姓名</p>
            <van-radio-group v-model="radio" @change="choice()" style="margin-left: 20px;">
                <van-radio name="1" style="margin-bottom: 12px;">机构持股</van-radio>
                <van-radio name="2">个人持股</van-radio>
            </van-radio-group>
            <br/><br/>
            <div v-if="show">
                <p><span>*</span>   2. 持股主体全称(含产品名称)</p>
                <van-field v-model="name" /><br/><br/>
                <p><span>*</span>   3. 请填写您持股主体的证件号码</p>
                <van-field v-model="id_number" /><br/><br/>
                <p><span>*</span>   4. 请填写您的深A股东账户号码/深A信用证券账户号码(必填10位数字)</p>
                <van-field v-model="stock_number" /><br/><br/>
                <p><span>*</span>   5. 机构负责人/基金经理的姓名是</p>
                <van-field v-model="manager" /><br/><br/>
                <p><span>*</span>   6. 请填写申请人个人信息,(姓名/职务/身份证号码)</p>
                <van-field
                    v-model="message"
                    rows="3"
                    autosize
                    type="textarea"
                /><br/><br/>
                <p><span>*</span>   7. 请上传您的身份证正面照片/身份证反面照片/请上传机构持仓截图</p>
                <van-uploader  v-model="id_photo1" multiple :max-count="3"  :before-read="beforeRead"/><br/><br/>
                <p><span>*</span>   8. 请填写参与活动的手机号码(此号码和天猫登录号码需一致)</p>
                <van-field v-model="tell" /><br/><br/>
                
            </div>

            <div v-else>
                <p><span>*</span>   2. 请填写您的姓名</p>
                <van-field v-model="name2" /><br/><br/>
                <p><span>*</span>   3. 请填写您的身份证号</p>
                <van-field v-model="id_number2" /><br/><br/>
                <p><span>*</span>   4. 请填写您的深A股东账户号码/深A信用证券账户号码(必填10位数字)</p>
                <van-field v-model="stock_number2" /><br/><br/>
                <p><span>*</span>   5. 请上传您的身份证正面照片/身份证反面照片/持仓截图</p>
                <van-uploader  v-model="id_photo2" multiple :max-count="3"  :before-read="beforeRead"/><br/><br/>
                <p><span>*</span>   6. 请填写参与活动的手机号码(此号码和天猫登录号码需一致)</p>
                <van-field v-model="tell2" /><br/><br/>
            </div>

        </main>

        <footer >
            <van-button type="info" size="small" @click="submit()" style="width: 100%;">提交</van-button>
        </footer>
    </div>
</template>

<script>
    import { url } from '../router/api';
	export default{
        data() {
            return {
                radio:'1',
                show:true,

                name:'',
                id_number:'',
                stock_number:'',
                manager:'',
                message:'',
                id_photo1:[],
                tell:'',

                name2:'',
                id_number2:'',
                stock_number2:'',
                id_photo2:[],
                tell2:'',
            };
        },
        methods: {
            choice() {
                if(this.radio=='1') {
                    this.show = true,
                    this.name = '',
                    this.id_number = '',
                    this.stock_number = '',
                    this.manager = '',
                    this.message = '',
                    this.id_photo1 = [],
                    this.tell=''
                } else {
                    this.show = false,
                    this.name2 = '',
                    this.id_number2 = '',
                    this.stock_number2 = '',
                    this.id_photo2 = [],
                    this.tell2 = ''
                }
            },
            beforeRead(file){
               return this.$compress(file)
            },

            sure(n) {
                if(n==1) {
                    if(this.id_photo1.length<3) {
                        this.$dialog.alert({
                            title: '提示',
                            message: '请上传三张照片',
                        }).then(() => {
                            return;
                        });
                    } else {
                        this.loading = this.$loading({
                            lock: true,
                            text: 'Loading',
                            spinner: '加载中',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        var formData =new FormData();
                        this.id_photo1.map(item=>{
                            formData.append('file[]',item.file);
                        })
                        this.axios.post(url +'xs/upload_gudong1',(formData),{
                            headers: {  'Content-Type': 'multipart/form-data;' }
                        }).then(res=> {
                            if(res.data.code==1) {
                                this.sure2(res.data.data)
                            }  else {
                                this.loading.close();
                            }
                        }).catch(err=> {
                            this.loading.close();
                            console.log(err);
                        });
                    }
                } else if(n==2) {
                    if(this.id_photo2.length<3) {
                        this.$dialog.alert({
                            title: '提示',
                            message: '请上传三张照片',
                        }).then(() => {
                            return;
                        });
                    } else {
                        this.loading = this.$loading({
                            lock: true,
                            text: 'Loading',
                            spinner: '加载中',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        var formData =new FormData();
                        this.id_photo2.map(item=>{
                            formData.append('file[]',item.file);
                        })
                        this.axios.post(url +'xs/upload_gudong2',(formData),{
                            headers: {  'Content-Type': 'multipart/form-data;' }
                        }).then(res=> {
                            if(res.data.code==1) {
                                this.sure3(res.data.data)
                            }  else {
                                this.loading.close();
                            }
                        }).catch(err=> {
                            this.loading.close();
                            console.log(err);
                        });
                    }
                }
            },

            sure2(photo) {
                this.axios.get(url+'xs/gdAdd1', {
                    params:{
                        radio:this.radio,
                        name:this.name,
                        id_number:this.id_number,
                        stock_number:this.stock_number,
                        manager:this.manager,
                        message:this.message,
                        url:photo.toString(),
                        tell:this.tell
                    }
                }).then(res=> {
                    if(res.status==200) {
                        this.loading.close();
                        this.$dialog.alert({
                            title: '提示',
                            message: '提交成功',
                        }).then(() => {
                            this.show = true,
                            this.name = '',
                            this.id_number = '',
                            this.stock_number = '',
                            this.manager = '',
                            this.message = '',
                            this.id_photo1 = [],
                            this.tell=''
                        });
                    } else {
                        this.loading.close();
                    }
                }).catch(err=> {
                    this.loading.close();
                    console.log(err);
                });
            },

            sure3(photo) {
                this.axios.get(url+'xs/gdAdd2', {
                    params:{
                        radio:this.radio,
                        name:this.name2,
                        id_number:this.id_number2,
                        stock_number:this.stock_number2,
                        url:photo.toString(),
                        tell:this.tell2
                    }
                }).then(res=> {
                    if(res.status==200) {
                        this.loading.close();
                        this.$dialog.alert({
                            title: '提示',
                            message: '提交成功',
                        }).then(() => {
                            this.show = false,
                            this.name2 = '',
                            this.id_number2 = '',
                            this.stock_number2 = '',
                            this.id_photo2 = [],
                            this.tell2 = ''
                        });
                    } else {
                        this.loading.close();
                    }
                }).catch(err=> {
                    this.loading.close();
                    console.log(err);
                });
            },

            submit() {
                if(this.radio=='1') {
                    if(this.name=='') {
                        this.$dialog.alert({
                            title: '提示',
                            message: '请填写持股主体',
                        }).then(() => {});
                    } else if(this.id_number=='') {
                        this.$dialog.alert({
                            title: '提示',
                            message: '请填写持股主体证件号码',
                        }).then(() => {});
                    } else if(this.stock_number=='') {
                        this.$dialog.alert({
                            title: '提示',
                            message: '请填写深A股东账户号码/深A信用证券账户号码',
                        }).then(() => {});
                    } else if(this.manager=='') {
                        this.$dialog.alert({
                            title: '提示',
                            message: '请填写机构负责人/基金经理',
                        }).then(() => {});
                    }  else if(this.message=='') {
                        this.$dialog.alert({
                            title: '提示',
                            message: '请填写个人信息(职务/身份证/身份证号码)',
                        }).then(() => {});
                    }  else if(this.id_photo1=='') {
                        this.$dialog.alert({
                            title: '提示',
                            message: '请上传身份证正反面照片及持仓截图',
                        }).then(() => {});
                    }  else if(this.tell=='') {
                        this.$dialog.alert({
                            title: '提示',
                            message: '请填写参与活动的手机号码(此号码和天猫登录号码需一致)',
                        }).then(() => {});
                    } else {
                        this.$dialog.confirm({
                            title: '提示',
                            message: '是否确定提交',
                        }).then(() => {
                            this.sure(1)
                        }).catch(() => {});
                    }
                }

                if(this.radio=='2') {
                    if(this.name2=='') {
                        this.$dialog.alert({
                            title: '提示',
                            message: '请填写姓名',
                        }).then(() => {});
                    } else if(this.id_number2=='') {
                        this.$dialog.alert({
                            title: '提示',
                            message: '请填写身份证号',
                        }).then(() => {});
                    } else if(this.stock_number2=='') {
                        this.$dialog.alert({
                            title: '提示',
                            message: '请填写深A股东账户号码/深A信用证券账户号码',
                        }).then(() => {});
                    } else if(this.id_photo2=='') {
                        this.$dialog.alert({
                            title: '提示',
                            message: '请上传身份证正反面照片及持仓截图',
                        }).then(() => {});
                    }   else if(this.tell2=='') {
                        this.$dialog.alert({
                            title: '提示',
                            message: '请填写参与活动的手机号码(此号码和天猫登录号码需一致)',
                        }).then(() => {});
                    } else {
                        this.$dialog.confirm({
                            title: '提示',
                            message: '是否确定提交',
                        }).then(() => {
                            this.sure(2)
                        }).catch(() => {});
                    }
                }
               
            },
        }
    }
</script>

<style scoped="cabteeb" lang='less'>
    .feedback {
        padding: 20px 30px;
        h3 {
            text-align: center;
            color: #1989FA;
            line-height: 12px;
        }
        main {
            span {
                color: red;
                font-weight: 600;
            }
        }

        /* 全局样式覆盖 */
        /deep/ .van-field__control {
            border: 1px solid #DCDFE6; /* 红色边框 */
            margin-top: -10px;
            height: 30px;
        }



    }
</style>




